export default __webpack_public_path__ + "static/media/learningImg1.94423cb0.JPG";